import React from "react";
import { Helmet } from "react-helmet";
import { useLocation } from "react-router-dom";
import { canonicalUrl } from "../utils/seo";

const CanonicalHelmet = () => {
  const { pathname } = useLocation();

  if (pathname === "/blog" || pathname.startsWith("/blog/")) {
    return null;
  }

  return (
    <Helmet>
      <link rel="canonical" href={canonicalUrl(pathname)} />
    </Helmet>
  );
};

export default CanonicalHelmet;
